import { max, parseISO } from 'date-fns';

export const getReminderDate = (customer) => {
    const today = new Date();
    return customer && customer.reminder ? max([parseISO(customer.reminder), today]) : today;
};
